module.exports = __webpack_public_path__ + "static/Laptop1_MobilePR-60c71a14d774c993bb9258881c1a99d2.mp4";